export function getStaticImageSrc<TFilePath extends string>(
  filePath: TFilePath,
  staticImgPath: string,
): `$staticImgPath/${TFilePath}` {
  return `${staticImgPath}${filePath}` as `$staticImgPath/${TFilePath}`;
}
